"use client";
import React from 'react';
import { Link } from 'react-router-dom';
import MobileLogo from '../../../assets/images/resources/ubrandit-logo.svg'

const MobileMenu = ({ isSidebar, handleMobileMenu, handleSidebar }) => {
  // Removed unused state and function
  return (
    <>
      {/*End Mobile Menu */}
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
            <Link to="/" aria-label="logo image" onClick={handleMobileMenu}>
              <img src={MobileLogo} alt="U Brand It Logo" />
            </Link>
          </div>
          {/* /.logo-box */}
          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li>
                <Link to="/" onClick={handleMobileMenu}>
                  <i className="fa fa-home" />
                  <span>Home</span>
                </Link>
              </li>

              <li>
                <Link to="/services" onClick={handleMobileMenu}>
                  <i className="fa fa-briefcase" />
                  <span>Services</span>
                </Link>
              </li>

              <li>
                <Link to="/contact" onClick={handleMobileMenu}>
                  <i className="fa fa-envelope" />
                  <span>Contact</span>
                </Link>
              </li>
            </ul>
            
            {/* Footer Links */}
            <div className="mobile-nav__footer-links">
              <ul className="list-unstyled">
                <li>
                  <Link to="/privacy" onClick={handleMobileMenu}>
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" onClick={handleMobileMenu}>
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="mobile-nav__contact-section">
            <h4 className="mobile-nav__contact-title">Get in Touch</h4>
            <ul className="mobile-nav__contact list-unstyled">
              <li>
                <i className="fa fa-phone-alt" />
                <a href="tel:800-721-5822">
                  800-721-5822
                </a>
              </li>
              <li>
                <i className="fa fa-envelope" />
                <a href="mailto:general@ubranditpa.com">
                  general@ubranditpa.com
                </a>
              </li>
            </ul>
            
            {/* CTA Button */}
            <div className="mobile-nav__cta">
              <Link to="/contact" className="thm-btn mobile-nav__cta-btn" onClick={handleMobileMenu}>
                Get a Quote <span className="icon-arrow-right"></span>
              </Link>
            </div>
          </div>
          {/* /.mobile-nav__contact */}
        </div>
        {/* /.mobile-nav__content */}
      </div>

      <div
        className="nav-overlay"
        style={{ display: `${isSidebar ? "block" : "none"}` }}
        onClick={handleSidebar}
      />
    </>
  );
};
export default MobileMenu;
